export const HIDDEN_NAV_MENU_KEYS = ["config", "locale", "metadata"];

export const SideNavBarMenu = [
    {
        label: "CONFIG",
        path: "/config",
        menuIcon: "DeviceHub",
        key: "config",
    },
    {
        label: "COPY",
        path: "/localization",
        menuIcon: "Language",
        key: "locale",
    },
    {
        label: "INGESTION",
        path: "/ingestion",
        menuIcon: "Ingestion",
        key: "ingestion",
    },
    {
        label: "GENRE MANAGEMENT",
        path: "/genre-management",
        menuIcon: "Page",
        key: "genre",
    },
    {
        label: "AVAILS",
        path: "/avails",
        menuIcon: "Avails",
        key: "metadata",
    },
    {
        label: "AVAILS+",
        path: "/avails-plus",
        menuIcon: "AvailsPlus",
        key: "mam",
    },
    {
        label: "DSAR",
        path: "/dsar",
        menuIcon: "Dsar",
        key: "dsar",
    },
    {
        label: "USERS",
        path: "/user-management",
        menuIcon: "User",
        key: "user",
    },
];

export const DEFAULT_MENU = ["user"];

export const HERO_CAROUSEL = "hero_carousel";
export const CW_CAROUSEL = "continue_watching";
export const POPULAR_SEARCH = "popular_search";
export const HOME_PAGE = "home_page";
export const SERIES_PAGE = "series_landing";
export const MOVIES_PAGE = "movies_landing";

export const GENRE = "genre";
export const THEMATIC = "thematic";
export const SINGULAR_PROMO = "singular_promo";
export const EPISODIC_RAIL = "episodic_rail";
export const MY_LIST = "my_list";
export const COLLECTIONS = "collections_rail";

export const POSTER_HORIZONTAL = "poster_horizontal";
export const POSTER_VERTICAL = "poster_vertical";
export const POPULAR_SEARCHES = "popular_searches";
export const NO_RESULTS = "no_results";

export const HERO_RAIL = "hero";
export const OTHER_RAIL = "others";
export const INGESTION_PROGRESS_ERROR = "INGESTION_PROGRESS_ERROR";
export const INGESTION_PROGRESS_SUCCESS = "INGESTION_PROGRESS_SUCCESS";
export const PAGE_NAME_MISSING = "Name is required";
export const LIVE = "live";
export const DRAFT_STATUS = "draft";
export const SCHEDULED_STATUS = "scheduled";
export const BUCKET_NAME = "root";
export const FILE = "FILE";
export const FOLDER = "FOLDER";
export const ERROR_HEADERS_CSV = [
    { label: "RowNo", key: "rowNo" },
    { label: "Errors", key: "errorMessage" },
];

export const UNIQUE_NAME_ERROR =
    "Canonical name is already in use. Please enter a different name.";
export const SOMETHING_WENT_WRONG = "Something went wrong!";
export const PAGE_TEMPLATE: any = {
    series_landing: "Series",
    movies_landing: "Movies",
    home_page: "Home",
    popular_search: "Search",
};
export const HORIZONTAL_RAIL = {
    label: "Poster Horizontal",
    key: "poster_horizontal",
};
export const BANNER_TYPES = [
    { value: "movies", label: "Movies" },
    { value: "series", label: "Series" },
    { value: "trailer", label: "Trailer" },
    { value: "spotlight", label: "Spotlight" },
];
export const BANNER_TYPES_CATEGORY_1 = ["movies", "series", "trailer"];
export const BANNER_TYPES_CATEGORY_2 = ["spotlight"];
export const BANNER_TYPES_CATEGORY_3 = ["movies", "series"];

export const SYNOPSIS_LIMIT = 360;
export const TITLE_TEXT_LIMIT = 20;

export const BANNER_PLACEHOLDER_MESSAGE_WEB =
    "The required image resolution is a 16:9 aspect ratio with a minimum of 3840 x 2160 pixels";
export const BANNER_PLACEHOLDER_MESSAGE_MOBILE =
    "The required image resolution is a 2:3 aspect ratio with a minimum of 800 x 1200 pixels";
export const THEMATIC_PLACEHOLDER_MESSAGE =
    "The required image resolution is a 1:1 aspect ratio with a minimum of 392 x 392 pixels";
export const SINGULAR_PROMO_WEB_PLACEHOLDER_MESSAGE =
    "The required image resolution is a 16:9 aspect ratio with a minimum of 3840 x 2160 pixels";
export const SINGULAR_PROMO_MOBILE_PLACEHOLDER_MESSAGE =
    "The required image resolution is a 2:3 aspect ratio with a minimum of 800 x 1200 pixels";

export const BANNER_ERROR_MESSAGE =
    "Image does not meet the resolution requirements. Please resize the image and try again";
export const BANNER_DIMENSION = {
    WIDTH: 3840,
    HEIGHT: 2160,
};
export const BANNER_DIMENSION_MOBILE = {
    WIDTH: 800,
    HEIGHT: 1200,
};
export const COLLECTION_DIMENSION = {
    WEB: {
        WIDTH: 3840,
        HEIGHT: 2160,
    },
    MOBILE: {
        WIDTH: 800,
        HEIGHT: 1200,
    },
};
export const BANNER_ACCEPTED_FILE = ["image/jpeg", "image/jpg", "image/png"];
export const TAG_TEXT_LIMIT = 30;
export const TAG_TAGS_LIMIT = 15;
export const NEW_ROW = "new_row";
export const RAIL_TEXT_LIMIT = 30;
export const GENRE_RAIL_TITLE = 30;
export const GENRE_TITLE_LIMIT = 20;
export const BANNER_TYPE_CONTENT_TYPE = {
    movies: ["movie"],
    series: ["series"],
    trailer: ["movie_trailer", "series_trailer"],
};
export const THEMATIC_MIN_IMAGE_DIMENSION = {
    WIDTH: 100,
    HEIGHT: 100,
};

export const SINGULAR_WEB_MIN_IMAGE_DIMENSION = {
    WIDTH: 100,
    HEIGHT: 100,
};

export const SINGULAR_MOBILE_MIN_IMAGE_DIMENSION = {
    WIDTH: 100,
    HEIGHT: 100,
};

export const THEMATIC_VALIDATION = {
    TITLE: 30,
    DESCRIPTION: 80,
};
export const METADATA_MANAGEMENT = {
    DEFAULT_SKIP: 0,
    DEFAULT_LIMIT: 25,
};

export const AVAILS_PLUS_MANAGEMENT = {
    DEFAULT_SKIP: 0,
    DEFAULT_LIMIT: 25,
};

export const SINGULAR_PROMO_VALIDATION = {
    DESCRIPTION: 120,
};

export const INGESTION_STATUS = [
    {
        label: "Failed",
        key: "FAILED",
    },
    {
        label: "Completed",
        key: "COMPLETED",
    },
    {
        label: "In Progress",
        key: "IN-PROGRESS",
    },
];
export const IMAGE_URL = "imageUrl";
export const MOBILE_IMAGE_URL = "mobileImageUrl";
export const NO_CONTENT_PLAYLIST =
    "No assets found in playlist. Please choose a different one.";
export const ALLOWED_CONTENT_PROMO = [
    "episode",
    "movie",
    "series_extras",
    "movie_extras",
];
export const PROMO = "promo";
export const MIN_SCHEDULE_DURATION = 5;
export const PUBLISH_DATE_HELPER_TEXT =
    "* In case a similar Live mapping exists at this publish date and time for selected asset, Will be overridden by this mapping and previous Live mapping will be moved to Draft state automatically.";
export const UNPUBLISH_DATE_HELPER_TEXT =
    "* Will be automatically unpublished at set date and time and be moved to Drafts";
export const PER_DAY_COUNT_HELPER_TEXT =
    "* Number of times per day, selected promo to be displayed to Account user on selected Asset. Do not display for that day after this count hits";
export const TOTAL_COUNT_HELPER_TEXT =
    "* Total number of times, selected promo to be displayed to Account user on selected Asset. Do not display after this count hits";
export const CREATE_MAPPING_TITLE = "Create Promo Video to Asset Mapping";
export const UPDATE_MAPPING_TITLE = "Edit Draft Mapping";
export const LIVE_MAPPING_TITLE = "View Live Mapping";
export const THEMATIC_BACKGROUNG_SELECTION = {
    IMAGE: "image",
    COLOR: "color",
};
export const UNPUBLISH_SUCCESS =
    "Live mapping unpublished successfully and moved to Draft section";
export const UNSCHEDULE_SUCCESS =
    "Scheduled mapping unscheduled successfully and moved to Draft section";
export const UNPUBLISH_ERROR = "Failed to unpublish. Please try again";
export const UNSCHEDULE_ERROR = "Failed to unschedule. Please try again";
export const DELETE_PROMO_FAILED = "Failed to delete. Please try again";
export const DELETE_DRAFT_PROMO_SUCCESS = "Draft mapping deleted successfully";
export const DELETE_SCHEDULE_PROMO_SUCCESS =
    "Scheduled mapping deleted successfully";

export const DELETE_YMAL_SUCCESS =
    "You May Also Like mapping deleted successfully";
export const DELETE_YMAL_FAILED = "Failed to delete. Please try again";

export const BOOST_ACTION = {
    BOOST: "BOOST",
    DELETE: "DELETE",
};

export const ENVIRONMENTS = {
    DEV: "DEV",
    STAGE: "STAGE",
    PROD: "PROD",
};

export const S3_FOLDER_ENV_NAMES = [
    { envLabel: "wonder-asset-inventory-prod", envName: "PROD" },
    { envLabel: "kingdom-asset-inventory", envName: "DEV" },
];

export const LOGS_STATUS = {
    FAILED: "FAILED",
    COMPLETED: "COMPLETED",
};
